module.exports = __webpack_public_path__ + "static/media/vission.42ad658a.png";